(function () {
  if (window.RDCartUpsell) return;

  var autoKeys = {};
  var ERROR_KEY = 'rd-cart-upsell-error';
  // Money matches Liquid's money_without_trailing_zeros in the same cart ("$84"),
  // read from the "moneyZero" sample the snippet renders.
  var moneyPrefix = '$';
  var moneySuffix = '';

  // Minimal UUID helper for offer-analytics operationIds: kept local since
  // this file has no module system to share it with rd-offer-events.js.
  function rdUuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      try {
        return window.crypto.randomUUID();
      } catch (error) {
        // fall through to manual fallback
      }
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // Dispatches the offer-added signal that rd-offer-events.js listens for.
  // Best-effort only: analytics must never interfere with the cart flow.
  function dispatchOfferAdded(detail) {
    try {
      document.dispatchEvent(new CustomEvent('rd:offer-added', { detail: detail }));
    } catch (error) {
      // ignore: analytics is opt-in and non-critical
    }
  }

  function routesFallback(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.status >= 400 || json.errors) {
          throw json;
        }
        return json;
      });
    });
  }

  function postJson(url, body) {
    return fetchJson(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });
  }

  function getSectionsToRender(context) {
    var sections = context === 'page' ? ['cart-icon-bubble'] : ['cart-drawer', 'cart-icon-bubble'];
    // main-cart-items/main-cart-footer are JSON-template sections: their real
    // Section Rendering API id is the template-scoped value in data-id (e.g.
    // "template--123__cart-items"), not the literal element id.
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    if (itemsEl && itemsEl.dataset.id) sections.push(itemsEl.dataset.id);
    if (footerEl && footerEl.dataset.id) sections.push(footerEl.dataset.id);
    return sections;
  }

  function withRenderedSections(body, context) {
    return Object.assign({}, body, {
      sections: getSectionsToRender(context),
      sections_url: window.location.pathname
    });
  }

  function storePendingError(context, message) {
    try {
      sessionStorage.setItem(ERROR_KEY, JSON.stringify({
        context: context || '',
        message: message || 'Cart update failed. Your cart was refreshed.'
      }));
    } catch (error) {
      window.rdCartUpsellPendingError = {
        context: context || '',
        message: message || 'Cart update failed. Your cart was refreshed.'
      };
    }
  }

  function takePendingError(context) {
    var payload = null;

    try {
      payload = JSON.parse(sessionStorage.getItem(ERROR_KEY) || 'null');
      if (payload && (!payload.context || payload.context === context)) {
        sessionStorage.removeItem(ERROR_KEY);
      } else {
        payload = null;
      }
    } catch (error) {
      payload = null;
    }

    if (!payload && window.rdCartUpsellPendingError && (!window.rdCartUpsellPendingError.context || window.rdCartUpsellPendingError.context === context)) {
      payload = window.rdCartUpsellPendingError;
      window.rdCartUpsellPendingError = null;
    }

    return payload && payload.message ? payload.message : '';
  }

  function setMoneyFormat(zero) {
    var text = String(zero || '').trim();
    var index = text.indexOf('0');
    if (index === -1) return;
    moneyPrefix = text.slice(0, index);
    moneySuffix = text.slice(index + 1).replace(/^[.,]0+/, '');
  }

  function money(cents) {
    var value = Math.round(Number(cents || 0)) / 100;
    var hasCents = Math.round(Number(cents || 0)) % 100 !== 0;
    return moneyPrefix + value.toLocaleString('en-NZ', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0
    }) + moneySuffix;
  }

  // Superset tiers arrive as the rd-superset-tiers string ("2:15,3:30,4:50", NZD dollars).
  function parseTiers(value) {
    return String(value || '').split(',').map(function (pair) {
      var parts = pair.split(':');
      return { qty: parseInt(parts[0], 10), off: Math.round(parseFloat(parts[1]) * 100) };
    }).filter(function (tier) {
      return tier.qty > 0 && tier.off >= 0;
    }).sort(function (a, b) {
      return a.qty - b.qty;
    });
  }

  function supersetSaving(tiers, count) {
    var off = 0;
    tiers.forEach(function (tier) {
      if (count >= tier.qty) off = tier.off;
    });
    return off;
  }

  function isSupersetLine(data, line) {
    var handles = (data.superset && data.superset.handles) || [];
    return handles.indexOf(line && line.productHandle) !== -1;
  }

  function lineUnitPrice(line) {
    var quantity = Math.max(1, cartLineQuantity(line) || 1);
    var total = Number(line.originalLinePrice != null ? line.originalLinePrice : (line.finalLinePrice || 0));
    return total / quantity;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function variantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(Boolean);
  }

  function variantFirstOption(variant) {
    return variantOptions(variant)[0] || variant.title || 'Default Title';
  }

  function isDefaultOption(value) {
    return normalize(value) === 'default title';
  }

  function isAvailableVariant(variant) {
    return variant && variant.available !== false;
  }

  // The cart adapter normally exposes variantId and some internal normalized
  // payloads expose the same native ID as merchandiseId. Exact native
  // matching accepts either normalized shape.
  function cartLineVariantId(line) {
    return line && (line.variantId != null ? line.variantId : line.merchandiseId);
  }

  function cartLineQuantity(line) {
    var quantity = Number(line && line.quantity);
    return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : 0;
  }

  function availableVariants(product) {
    return (product.variants || []).filter(isAvailableVariant);
  }

  function firstAvailableVariant(product) {
    return availableVariants(product)[0] || (product.variants || [])[0] || null;
  }

  function productOptionIndex(product) {
    var options = product.options || [];
    var sizeIndex = options.findIndex(function (option) {
      return normalize(option).indexOf('size') !== -1;
    });
    return sizeIndex >= 0 ? sizeIndex : 0;
  }

  function productOptionValues(product) {
    var index = productOptionIndex(product);
    var seen = {};
    return availableVariants(product).reduce(function (values, variant) {
      var value = variantOptions(variant)[index] || variantFirstOption(variant);
      if (!value || isDefaultOption(value) || seen[normalize(value)]) return values;
      seen[normalize(value)] = true;
      values.push(value);
      return values;
    }, []);
  }

  function findVariantByValue(product, value) {
    var index = productOptionIndex(product);
    var normalizedValue = normalize(value);
    return availableVariants(product).find(function (variant) {
      return normalize(variantOptions(variant)[index] || variantFirstOption(variant)) === normalizedValue;
    }) || null;
  }

  function componentIsOneSize(component) {
    var variants = component.variants || [];
    var values;

    if (component.hasOnlyDefaultVariant) return true;
    if ((component.options || []).length) {
      var optionNames = (component.options || []).map(normalize);
      if (optionNames.every(function (option) { return option === 'title' || option === 'default title'; })) return true;
    }

    values = variants.map(variantFirstOption).filter(function (value) {
      return value && !isDefaultOption(value);
    });
    if (values.length === 0) return true;

    return values.every(function (value) {
      var normalizedValue = normalize(value);
      return normalizedValue === 'one size' || normalizedValue === 'onesize' || normalizedValue === 'os';
    });
  }

  function mapBundleOptionToComponent(optionName, components) {
    var option = normalize(optionName);
    var best = null;
    var bestScore = 0;

    components.forEach(function (component) {
      if (componentIsOneSize(component)) return;
      var words = normalize(component.title || component.handle).split(' ').filter(function (word) {
        return word.length > 1 && word !== 'the';
      });
      var score = words.reduce(function (total, word) {
        return total + (option.indexOf(word) !== -1 ? 1 : 0);
      }, 0);
      normalize(component.handle).split(' ').forEach(function (word) {
        if (word.length > 1 && option.indexOf(word) !== -1) score += 1;
      });
      if (score > bestScore) {
        best = component;
        bestScore = score;
      }
    });

    return best;
  }

  function getComponentValueFromLine(line) {
    var options = Array.isArray(line.variantOptions) ? line.variantOptions : [];
    return options.find(function (value) {
      return value && !isDefaultOption(value);
    }) || line.variantTitle || '';
  }

  function resolveBundleVariant(bundle, selections) {
    var optionNames = bundle.optionNames || [];
    var components = bundle.components || [];
    var optionComponents = optionNames.map(function (optionName) {
      return mapBundleOptionToComponent(optionName, components);
    });

    if (optionNames.length && optionComponents.some(function (component) { return !component; })) {
      return null;
    }
    var seenMappedComponents = {};
    for (var i = 0; i < optionComponents.length; i += 1) {
      var mappedComponent = optionComponents[i];
      if (!mappedComponent) continue;
      if (seenMappedComponents[mappedComponent.handle]) return null;
      seenMappedComponents[mappedComponent.handle] = true;
    }

    return (bundle.variants || []).find(function (variant) {
      if (!isAvailableVariant(variant)) return false;

      var options = variantOptions(variant);
      return optionComponents.every(function (component, index) {
        var selected = selections[component.handle];
        return selected && normalize(options[index]) === normalize(selected);
      });
    }) || null;
  }

  // A selectable Full Stack has no stable relationship between its display
  // option names and its components. Only the generated native projection is
  // allowed to identify its component/parent variants in the cart.
  function nativeBundleRows(bundle) {
    var projection = bundle && bundle.nativeProjection;
    if (!projection || Number(projection.schema) !== 1 || String(projection.parentProductId) !== String(bundle.productId) || !Array.isArray(projection.componentProducts) || !Array.isArray(projection.parents)) return null;
    var components = bundle.components || [];
    var products = {};
    var variants = {};
    var parentVariants = {};
    var roles = {};
    var invalid = false;
    components.forEach(function (component) {
      if (!component || component.productId == null || products[String(component.productId)]) { invalid = true; return; }
      products[String(component.productId)] = component;
      (component.variants || []).forEach(function (variant) {
        if (!variant || variant.id == null || variants[String(variant.id)]) { invalid = true; return; }
        variants[String(variant.id)] = { component: component, variant: variant };
      });
    });
    (bundle.variants || []).forEach(function (variant) {
      if (!variant || variant.id == null || typeof variant.available !== 'boolean' || typeof variant.price !== 'number' || !Number.isSafeInteger(variant.price) || variant.price <= 0 || parentVariants[String(variant.id)]) { invalid = true; return; }
      parentVariants[String(variant.id)] = variant;
    });
    projection.componentProducts.forEach(function (definition) {
      if (!definition || ['tee', 'cap', 'shorts'].indexOf(definition.role) === -1 || !products[String(definition.productId)] || roles[String(definition.productId)]) { invalid = true; return; }
      roles[String(definition.productId)] = definition.role;
    });
    if (invalid || Object.keys(products).length !== Object.keys(roles).length || !Object.keys(parentVariants).length || !Object.keys(variants).length || !projection.parents.length) return null;
    var seenParents = {};
    var seenCompositions = {};
    var rows = [];
    projection.parents.forEach(function (row) {
      var ids = row || {};
      var parentId = String(ids.parentVariantId || '');
      var teeId = String(ids.teeVariantId || '');
      var capId = String(ids.capVariantId || '');
      var shortsId = String(ids.shortsVariantId || '');
      var composition = teeId + '|' + capId + '|' + shortsId;
      if (!parentVariants[parentId] || !variants[teeId] || !variants[capId] || !variants[shortsId] || seenParents[parentId] || seenCompositions[composition] || roles[String(variants[teeId].component.productId)] !== 'tee' || roles[String(variants[capId].component.productId)] !== 'cap' || roles[String(variants[shortsId].component.productId)] !== 'shorts') { invalid = true; return; }
      seenParents[parentId] = true;
      seenCompositions[composition] = true;
      rows.push({ parent: parentVariants[parentId], tee: variants[teeId], cap: variants[capId], shorts: variants[shortsId], ids: { tee: teeId, cap: capId, shorts: shortsId } });
    });
    var teeIds = {}, shortsIds = {}, capIds = {};
    Object.keys(variants).forEach(function (id) {
      var role = roles[String(variants[id].component.productId)];
      if (role === 'tee') teeIds[id] = true;
      if (role === 'shorts') shortsIds[id] = true;
      if (role === 'cap') capIds[id] = true;
    });
    // Full Stack's fixed contract is one cap with every tee/shorts pair.
    if (invalid || rows.length !== Object.keys(parentVariants).length || Object.keys(capIds).length !== 1 || rows.length !== Object.keys(teeIds).length * Object.keys(shortsIds).length) return null;
    return rows;
  }

  // The cart's Full Stack pieces, matched by exact native variant IDs. With
  // several lines for one piece (two different tops, say) the first line in
  // cart order is used: the cart total is the same whichever top goes in.
  //   all three present      -> 'full'    (Switch)
  //   top + shorts           -> 'partial' (add the one cap)
  //   anything else missing  -> 'pick'    (choose the missing top and/or shorts size)
  function analyzeNativeBundle(bundle, cartLines) {
    var rows = nativeBundleRows(bundle);
    if (!rows) return null; // A malformed projection must never fall back to title heuristics.
    var roleOf = {};
    rows.forEach(function (row) {
      roleOf[row.ids.tee] = 'tee';
      roleOf[row.ids.cap] = 'cap';
      roleOf[row.ids.shorts] = 'shorts';
    });
    var present = { tee: null, cap: null, shorts: null };
    cartLines.forEach(function (line) {
      if (cartLineQuantity(line) <= 0 || line.hasSellingPlan || line.hasProperties) return;
      var role = roleOf[String(cartLineVariantId(line))];
      if (role && !present[role]) present[role] = line;
    });
    if (!present.tee && !present.cap && !present.shorts) return null;

    var teeId = present.tee ? String(cartLineVariantId(present.tee)) : null;
    var shortsId = present.shorts ? String(cartLineVariantId(present.shorts)) : null;
    var matches = rows.filter(function (row) {
      if (!isAvailableVariant(row.parent)) return false;
      if (teeId ? row.ids.tee !== teeId : !isAvailableVariant(row.tee.variant)) return false;
      if (shortsId ? row.ids.shorts !== shortsId : !isAvailableVariant(row.shorts.variant)) return false;
      if (!present.cap && !isAvailableVariant(row.cap.variant)) return false;
      return true;
    });
    if (!matches.length) return null;

    var lines = [present.tee, present.cap, present.shorts].filter(Boolean);
    var first = matches[0];
    var base = {
      native: true,
      bundle: bundle,
      components: [first.tee.component, first.cap.component, first.shorts.component],
      lines: lines,
      selections: {},
      present: present,
      rows: matches
    };
    if (teeId && shortsId) {
      if (present.cap) return Object.assign(base, { type: 'full', variant: first.parent });
      return Object.assign(base, { type: 'partial', missing: first.cap.component, missingVariant: first.cap.variant, variant: first.parent });
    }
    return Object.assign(base, { type: 'pick', needTee: !teeId, needShorts: !shortsId, needCap: !present.cap });
  }

  function analyzeBundles(data) {
    var cartLines = (data.cartItems || []).filter(function (line) {
      return !line.isBundleParent && !line.isBundleChild;
    });

    for (var b = 0; b < (data.bundles || []).length; b += 1) {
      var bundle = data.bundles[b];
      if (bundle.nativeProjection) {
        var nativeCandidate = analyzeNativeBundle(bundle, cartLines);
        if (nativeCandidate) return nativeCandidate;
        continue;
      }
      var components = (bundle.components || []).filter(Boolean);
      if (components.length < 2) continue;

      var selections = {};
      var selectedLines = [];
      var missing = [];
      var ambiguous = false;

      components.forEach(function (component) {
        var lines = cartLines.filter(function (line) {
          return line.productHandle === component.handle;
        });

        if (lines.length === 0) {
          missing.push(component);
          return;
        }

        if (lines.length > 1 || lines[0].hasSellingPlan || lines[0].hasProperties) {
          ambiguous = true;
          return;
        }

        selectedLines.push(lines[0]);
        selections[component.handle] = componentIsOneSize(component) ? 'One Size' : getComponentValueFromLine(lines[0]);
      });

      if (ambiguous) {
        return {
          type: 'ambiguous-full',
          bundle: bundle,
          components: components,
          message: 'Switch to bundle is paused because this cart has duplicate, quantity, custom, or selling-plan component lines.'
        };
      }

      if (missing.length === 0) {
        var fullVariant = resolveBundleVariant(bundle, selections);
        if (fullVariant) {
          return {
            type: 'full',
            bundle: bundle,
            components: components,
            lines: selectedLines,
            selections: selections,
            variant: fullVariant
          };
        }
      }

      if (missing.length === 1 && selectedLines.length === components.length - 1) {
        var mappedMissing = (bundle.optionNames || []).some(function (optionName) {
          return mapBundleOptionToComponent(optionName, components) && mapBundleOptionToComponent(optionName, components).handle === missing[0].handle;
        });
        if (!componentIsOneSize(missing[0]) && !mappedMissing) continue;

        return {
          type: 'partial',
          bundle: bundle,
          components: components,
          lines: selectedLines,
          selections: selections,
          missing: missing[0]
        };
      }
    }

    return null;
  }

  // The Full Stack row only shows when it saves at least this much (cents),
  // after any Superset saving it costs.
  var MIN_FULL_STACK_SAVING = 1000;

  function linesUnitTotal(lines) {
    return (lines || []).reduce(function (total, line) {
      return total + lineUnitPrice(line);
    }, 0);
  }

  function optionIndex(component, names) {
    var index = (component && component.options ? component.options : []).map(normalize).findIndex(function (option) {
      return names.indexOf(option) !== -1;
    });
    return index;
  }

  function variantOrder(component, variant) {
    var index = (component.variants || []).findIndex(function (item) {
      return String(item.id) === String(variant.id);
    });
    return index === -1 ? 999 : index;
  }

  // Options for a 'pick' candidate: one item per top colourway when the top is
  // missing, otherwise one shorts item. Each item knows its sizes, prices and saving.
  function pickPlan(data, candidate) {
    var present = candidate.present || {};
    var presentUnits = linesUnitTotal(candidate.lines);
    var supersetLoss = supersetLossFor(data, candidate.lines);
    var isNzd = data.currency === 'NZD';
    var loss = isNzd ? supersetLoss : 0;
    var rows = candidate.rows || [];
    var capPrice = candidate.needCap && rows[0] && typeof rows[0].cap.variant.price === 'number' ? rows[0].cap.variant.price : 0;
    var groups = [];
    var byKey = {};

    rows.forEach(function (row) {
      var key;
      if (candidate.needTee) {
        var colourIndex = optionIndex(row.tee.component, ['colour', 'color']);
        var colour = colourIndex >= 0 ? variantOptions(row.tee.variant)[colourIndex] : '';
        key = String(row.tee.component.productId) + '|' + normalize(colour);
        if (!byKey[key]) {
          byKey[key] = { component: row.tee.component, colour: colour, image: row.tee.variant.image || row.tee.component.image, tees: {}, shorts: {}, parentPrice: null, teePrice: row.tee.variant.price, shortsPrice: null };
          groups.push(byKey[key]);
        }
      } else {
        key = 'shorts';
        if (!byKey[key]) {
          byKey[key] = { component: row.shorts.component, colour: '', image: candidate.needCap ? (candidate.bundle.image || row.shorts.component.image) : (row.shorts.variant.image || row.shorts.component.image), tees: {}, shorts: {}, parentPrice: null, teePrice: 0, shortsPrice: null };
          groups.push(byKey[key]);
        }
      }
      var group = byKey[key];
      if (candidate.needTee) group.tees[row.ids.tee] = row.tee;
      if (candidate.needShorts) {
        group.shorts[row.ids.shorts] = row.shorts;
        if (group.shortsPrice === null) group.shortsPrice = row.shorts.variant.price;
      }
      if (group.parentPrice === null || row.parent.price < group.parentPrice) group.parentPrice = row.parent.price;
    });

    var items = groups.map(function (group) {
      var separate = presentUnits + (candidate.needTee ? Number(group.teePrice || 0) : 0) + (candidate.needShorts ? Number(group.shortsPrice || 0) : 0) + capPrice;
      return Object.assign(group, {
        separate: separate,
        missingPrice: separate - presentUnits,
        payExtra: group.parentPrice - presentUnits + loss,
        saving: separate - group.parentPrice - loss
      });
    }).filter(function (item) {
      return item.parentPrice > 0 && item.saving > 0;
    });
    if (!items.length) return null;
    var saving = Math.min.apply(null, items.map(function (item) { return item.saving; }));
    return {
      items: items,
      saving: saving,
      supersetLoss: supersetLoss,
      amountKnown: isNzd || supersetLoss === 0
    };
  }

  // What switching really changes: the bundle price against the separate pieces,
  // less any Superset saving lost when a loose top moves into the bundle.
  // Returns null when the row should not show (saves less than MIN_FULL_STACK_SAVING).
  function bundleOffer(data, candidate) {
    if (!candidate || !candidate.bundle) return null;
    var offer;
    if (candidate.type === 'pick') {
      offer = pickPlan(data, candidate);
    } else {
      var lines = candidate.lines || [];
      var replaced = linesUnitTotal(lines);
      var missingPrice = 0;
      if (candidate.type === 'partial') {
        missingPrice = candidate.native && candidate.missingVariant && typeof candidate.missingVariant.price === 'number' ? candidate.missingVariant.price : Number((candidate.missing && candidate.missing.price) || 0);
      }
      var parentPrice = candidate.variant && typeof candidate.variant.price === 'number' ? candidate.variant.price : Number(candidate.bundle.price || 0);
      var supersetLoss = supersetLossFor(data, lines);
      var isNzd = data.currency === 'NZD';
      var loss = isNzd ? supersetLoss : 0;
      var separate = replaced + missingPrice;
      if (!(parentPrice > 0)) return null;
      offer = {
        separate: separate,
        parentPrice: parentPrice,
        missingPrice: missingPrice,
        payExtra: parentPrice - replaced + loss,
        supersetLoss: supersetLoss,
        saving: separate - parentPrice - loss,
        // Superset amounts are NZD; another currency converts them at checkout, so
        // the exact saving is only shown when no Superset saving is lost.
        amountKnown: isNzd || supersetLoss === 0
      };
    }
    if (!offer) return null;
    // Non-NZD: judge the threshold on the bundle saving less the Superset loss
    // converted at the storefront rate (Shopify converts the NZD discount the same way).
    var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    var judged = offer.amountKnown ? offer.saving : offer.saving - offer.supersetLoss * rate;
    if (judged < MIN_FULL_STACK_SAVING) return null;
    return offer;
  }

  // ---- Offer rules ---------------------------------------------------------
  // One pure ranking function: cart lines + product data in, ordered offers out.
  // Rules: ROYDED Website/Redesign-2026-09-22/coordination/CART-OFFER-RULES-2026-10-21.md
  //
  // Constants live here and in the data the snippet renders:
  //   tiers      data.superset.tiers (the rd-superset-tiers snippet, "2:15,3:30,4:50")
  //   threshold  data.threshold (free NZ shipping, cents)
  //   minimum    MIN_FULL_STACK_SAVING above ($10 after any Superset saving it costs)
  var MAX_OFFERS = 2;
  var MAX_CARDS = 4;
  // Order of the top colourways in the "Add a top" photo grid (waffle first, then the rag tops).
  var TOP_COLOUR_ORDER = ['waffle-raglan-tee|grey black', 'waffle-raglan-tee|green grey', 'rag-top|maroon', 'rag-top|grey'];

  function roleHandles(data) {
    var roles = { cap: ['cap'], shorts: ['shorts'] };
    var bundle = (data.bundles || []).filter(function (item) { return item && item.nativeProjection; })[0];
    if (!bundle) return roles;
    var byId = {};
    (bundle.components || []).forEach(function (component) {
      if (component) byId[String(component.productId)] = component.handle;
    });
    var found = { cap: [], shorts: [] };
    ((bundle.nativeProjection && bundle.nativeProjection.componentProducts) || []).forEach(function (definition) {
      if (found[definition.role] && byId[String(definition.productId)]) found[definition.role].push(byId[String(definition.productId)]);
    });
    return { cap: found.cap.length ? found.cap : roles.cap, shorts: found.shorts.length ? found.shorts : roles.shorts };
  }

  function findProduct(data, handle) {
    var pools = [data.upsellProducts || []];
    (data.bundles || []).forEach(function (bundle) { pools.push(bundle.components || []); });
    for (var i = 0; i < pools.length; i += 1) {
      for (var j = 0; j < pools[i].length; j += 1) {
        if (pools[i][j] && pools[i][j].handle === handle) return pools[i][j];
      }
    }
    return null;
  }

  function colourIndexOf(product) {
    var index = optionIndex(product, ['colour', 'color']);
    return index < 0 ? 0 : index;
  }

  // What is in the cart, from the cart lines alone. A top inside a Full Stack is
  // not a loose line, so it never counts toward the Superset.
  function cartContext(data) {
    var roles = roleHandles(data);
    var topHandles = (data.superset && data.superset.handles) || [];
    var bundleHandles = (data.bundles || []).map(function (bundle) { return bundle.handle; });
    var ctx = { tops: 0, topLines: [], hasCap: false, hasShorts: false, hasFullStack: false, topKeys: {} };
    (data.cartItems || []).forEach(function (line) {
      var quantity = cartLineQuantity(line);
      if (!quantity || line.isBundleChild) return;
      if (line.isBundleParent || bundleHandles.indexOf(line.productHandle) !== -1) {
        ctx.hasFullStack = true;
      } else if (topHandles.indexOf(line.productHandle) !== -1) {
        var product = findProduct(data, line.productHandle);
        var colour = (line.variantOptions || [])[product ? colourIndexOf(product) : 0] || '';
        ctx.tops += quantity;
        ctx.topLines.push(line);
        ctx.topKeys[line.productHandle + '|' + normalize(colour)] = true;
      } else if (roles.cap.indexOf(line.productHandle) !== -1) {
        ctx.hasCap = true;
      } else if (roles.shorts.indexOf(line.productHandle) !== -1) {
        ctx.hasShorts = true;
      }
    });
    return ctx;
  }

  // Superset saving lost when the cart's loose top moves into the bundle.
  function supersetLossFor(data, lines) {
    var tiers = parseTiers((data.superset || {}).tiers);
    var count = cartContext(data).tops;
    var topsUsed = (lines || []).filter(function (line) {
      return isSupersetLine(data, line);
    }).length;
    return supersetSaving(tiers, count) - supersetSaving(tiers, Math.max(0, count - topsUsed));
  }

  // Superset: the next tier, until the top tier is reached. Needs at least one loose top.
  function supersetOffer(data, ctx) {
    var tiers = parseTiers((data.superset || {}).tiers);
    if (!ctx.tops) return null;
    var next = tiers.filter(function (tier) { return tier.qty > ctx.tops; })[0];
    if (!next) return null;
    var isNzd = data.currency === 'NZD';
    return {
      type: 'superset',
      count: ctx.tops,
      nextQty: next.qty,
      nextOff: next.off,
      topNumber: ctx.tops + 1,
      extraOff: next.off - supersetSaving(tiers, ctx.tops),
      amountKnown: isNzd,
      fullStackTopsNote: ctx.hasFullStack
    };
  }

  // The Full Stack side of the rules. Returns null unless it really saves $10 or more.
  //   switch     top, cap and shorts all in the cart: convert in place
  //   complete   exactly one missing piece that can be added in one tap (cap, or shorts with a size)
  //   fullstack  anything else: opens the upgrade drawer
  function fullStackOffer(data, ctx) {
    if (ctx.hasFullStack) return null;
    var candidate = analyzeBundles(data);
    if (!candidate || candidate.type === 'ambiguous-full') return null;
    var offer = bundleOffer(data, candidate);
    if (!offer) return null;

    var result = {
      saving: offer.saving,
      supersetLoss: offer.supersetLoss,
      amountKnown: offer.amountKnown,
      candidate: candidate,
      bundle: candidate.bundle,
      topLine: ctx.topLines[0] || null,
      needs: { top: false, cap: false, shorts: false }
    };
    if (candidate.type === 'full') {
      return Object.assign(result, { type: 'switch', parentPrice: offer.parentPrice, separate: offer.separate, payExtra: 0, strike: 0 });
    }
    if (candidate.type === 'partial') {
      result.needs.cap = true;
      return Object.assign(result, { type: 'complete', piece: 'cap', payExtra: offer.payExtra, strike: offer.missingPrice, parentPrice: offer.parentPrice });
    }
    // 'pick': show the cheapest top colourway when a top is missing.
    var item = offer.items.slice().sort(function (a, b) { return a.payExtra - b.payExtra; })[0];
    result.needs = { top: !!candidate.needTee, cap: !!candidate.needCap, shorts: !!candidate.needShorts };
    var missing = (result.needs.top ? 1 : 0) + (result.needs.cap ? 1 : 0) + (result.needs.shorts ? 1 : 0);
    var single = missing === 1 && result.needs.shorts;
    return Object.assign(result, {
      type: single ? 'complete' : 'fullstack',
      piece: single ? 'shorts' : '',
      payExtra: item.payExtra,
      strike: item.missingPrice,
      parentPrice: item.parentPrice,
      saving: item.saving
    });
  }

  // Ordered offers (at most two) for a cart. Pure: nothing here touches the page.
  //   1. Switch first when the cart already makes a Full Stack worth $10 or more.
  //   2. A cap or shorts in the cart (outfit intent): the Full Stack's missing piece first.
  //   3. Otherwise tops: Superset's next tier (1 to 3 loose tops) first, Full Stack second.
  //   4. Otherwise whatever qualifies. Nothing qualifying means no offer section at all.
  function rankOffers(data) {
    var ctx = cartContext(data);
    var fs = fullStackOffer(data, ctx);
    var ss = supersetOffer(data, ctx);
    var ordered;
    if (fs && fs.type === 'switch') ordered = [fs, ss];
    else if (fs && (ctx.hasCap || ctx.hasShorts)) ordered = [fs, ss];
    else if (ss) ordered = [ss, fs];
    else ordered = [fs];
    return ordered.filter(Boolean).slice(0, MAX_OFFERS);
  }

  function sizeEntriesFor(product, variants) {
    var sizeIndex = optionIndex(product, ['size']);
    return variants.map(function (variant) {
      return {
        id: variant.id,
        label: sizeIndex >= 0 ? variantOptions(variant)[sizeIndex] : variantFirstOption(variant),
        available: isAvailableVariant(variant)
      };
    });
  }

  // Every top colourway on offer, in the agreed order, with its photo and sizes.
  function topColourways(data) {
    var list = [];
    ((data.superset && data.superset.handles) || []).forEach(function (handle) {
      var product = findProduct(data, handle);
      if (!product) return;
      var colourIdx = colourIndexOf(product);
      var groups = [];
      var byColour = {};
      (product.variants || []).forEach(function (variant) {
        var colour = variantOptions(variant)[colourIdx] || '';
        if (!byColour[normalize(colour)]) {
          byColour[normalize(colour)] = { colour: colour, variants: [], image: null };
          groups.push(byColour[normalize(colour)]);
        }
        var group = byColour[normalize(colour)];
        group.variants.push(variant);
        if (!group.image && variant.image) group.image = variant.image;
      });
      groups.forEach(function (group) {
        var key = handle + '|' + normalize(group.colour);
        var inStock = group.variants.filter(isAvailableVariant);
        if (!inStock.length) return;
        list.push({
          key: key,
          handle: handle,
          product: product,
          colour: group.colour,
          image: group.image || product.image,
          base: Number(inStock[0].price || product.price || 0),
          sizes: sizeEntriesFor(product, group.variants),
          order: TOP_COLOUR_ORDER.indexOf(key) === -1 ? 99 : TOP_COLOUR_ORDER.indexOf(key)
        });
      });
    });
    return list.sort(function (a, b) { return a.order - b.order; });
  }

  // Superset: ONE "Add a top" card (the builder sheet picks the colourway and size).
  //   Photo      the four top colourways in a 2x2 grid
  //   Price      "From $X", the cheapest top less the extra saving the next top unlocks, with the full price struck
  //   Tag        the badge on the card's top edge: the total saving the next tier gives, with a "+" while more
  //              tiers remain ("Save $15+", "Save $30+", "Save $50"). No badge when the amounts are not known.
  // Hidden once the cart holds the top tier's worth of loose tops (nothing more to save).
  function supersetCard(data, ctx) {
    var tiers = parseTiers((data.superset || {}).tiers);
    var ways = topColourways(data);
    var next = tiers.filter(function (tier) { return tier.qty > ctx.tops; })[0];
    if (!ways.length || !next) return null;
    var isNzd = data.currency === 'NZD';
    var base = Math.min.apply(null, ways.map(function (way) { return way.base; }));
    var extraOff = ctx.tops ? next.off - supersetSaving(tiers, ctx.tops) : 0;
    var effective = isNzd ? Math.max(0, base - extraOff) : base;
    var moreTiers = tiers.some(function (tier) { return tier.qty > next.qty; });
    var images = ways.map(function (way) { return way.image; }).filter(Boolean);
    return {
      offer: 'superset',
      kind: 'product',
      action: 'build',
      handle: 'superset-tees',
      title: 'Add a top',
      colour: 'Waffle or rag top',
      image: images[0] || '',
      gridImages: images.slice(0, 4),
      url: '/collections/superset-tees',
      tag: isNzd ? 'Save ' + money(next.off) + (moreTiers ? '+' : '') : '',
      priceText: 'From ' + money(effective),
      price: effective,
      strike: effective < base ? base : 0,
      note: ctx.hasFullStack ? 'Full Stack tops don\u2019t count' : '',
      sizes: [],
      tierQty: next.qty,
      amount: next.off
    };
  }

  // A plain product card: full price, + Add. One-size products add directly.
  function plainCard(data, product, colour, image, sizes, base, tag) {
    var oneSize = sizes.length === 1 && /^(one size|onesize|os|default title)$/.test(normalize(sizes[0].label));
    return {
      offer: tag ? 'plain' : 'listing',
      kind: 'product',
      action: oneSize ? 'add' : 'size',
      handle: product.handle,
      title: product.title,
      colour: colour,
      image: image || product.image,
      url: product.url,
      tag: tag,
      price: base,
      strike: 0,
      note: '',
      sizes: sizes,
      variantId: oneSize ? sizes[0].id : ''
    };
  }

  function singleProductCard(data, handle, tag) {
    var product = findProduct(data, handle);
    if (!product || !(product.variants || []).some(isAvailableVariant)) return null;
    var first = availableVariants(product)[0];
    return plainCard(data, product, '', first.image || product.image, sizeEntriesFor(product, product.variants), Number(first.price || product.price || 0), tag);
  }

  // The colour line of a single: "One size", or the range the product comes in ("S to XL").
  function sizeLine(sizes) {
    var labels = (sizes || []).map(function (size) { return size.label; }).filter(function (label) {
      return label && !isDefaultOption(label);
    });
    if (!labels.length) return 'One size';
    if (labels.length === 1) return /^(one size|onesize|os)$/.test(normalize(labels[0])) ? 'One size' : labels[0];
    return labels[0] + ' to ' + labels[labels.length - 1];
  }

  // The cap or the shorts as a card of their own: full price, no tag. The cap adds in one tap,
  // the shorts open the in-card size sheet.
  function singleCard(data, handle) {
    var card = singleProductCard(data, handle, '');
    if (!card) return null;
    card.offer = 'single';
    card.colour = sizeLine(card.sizes);
    return card;
  }

  // Empty cart: one card per DROP 003 top colourway (the colour is the photo).
  function emptyCards(data) {
    return topColourways(data).map(function (way) {
      return plainCard(data, way.product, way.colour, way.image, way.sizes, way.base, '');
    });
  }

  // Empty cart: the static Full Stack card under the row.
  function emptyFullStack(data) {
    var bundle = (data.bundles || [])[0];
    if (!bundle) return null;
    var prices = (bundle.variants || []).filter(isAvailableVariant).map(function (v) { return Number(v.price || 0); }).filter(Boolean);
    if (!prices.length) return null;
    var price = Math.min.apply(null, prices);
    var roles = roleHandles(data);
    var cheapestTop = Math.min.apply(null, topColourways(data).map(function (way) { return way.base; }));
    var cap = findProduct(data, roles.cap[0]);
    var shorts = findProduct(data, roles.shorts[0]);
    if (!cap || !shorts || !isFinite(cheapestTop)) return null;
    var strike = cheapestTop + Number(cap.price || 0) + Number(shorts.price || 0);
    return { bundle: bundle, price: price, strike: strike > price ? strike : 0, saving: Math.max(0, strike - price) };
  }

  function missingWords(needs) {
    var parts = [];
    if (needs.top) parts.push('a top');
    if (needs.cap) parts.push('the cap');
    if (needs.shorts) parts.push('shorts');
    return parts.length > 1 ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1] : parts[0] || '';
  }

  // Small photos of the pieces an upgrade adds, shown on the Full Stack card (21 Oct, option A).
  function missingPieces(data, needs) {
    var roles = roleHandles(data);
    var pieces = [];
    var names = [];
    if (needs.top) {
      var way = topColourways(data)[0];
      if (way && way.image) pieces.push(way.image);
      names.push('top');
    }
    if (needs.cap) {
      var cap = findProduct(data, roles.cap[0]);
      if (cap && cap.image) pieces.push(cap.image);
      names.push('cap');
    }
    if (needs.shorts) {
      var shorts = findProduct(data, roles.shorts[0]);
      if (shorts && shorts.image) pieces.push(shorts.image);
      names.push('shorts');
    }
    return { images: pieces, label: names.join(' + ') };
  }

  // The badge on every Full Stack card (switch, complete, upgrade).
  function fullStackTag(offer) {
    return offer.amountKnown ? (offer.supersetLoss > 0 ? 'Extra ' + money(offer.saving) + ' off' : 'Save ' + money(offer.saving)) : 'Bundle saving';
  }

  function fullStackCards(data, ctx, offer) {
    var bundle = offer.bundle;
    var bundleTitle = bundle.title || 'The Full Stack';
    var base = {
      offer: offer.type,
      kind: 'bundle',
      bundleHandle: bundle.handle || '',
      candidate: offer.candidate,
      saving: offer.saving,
      payExtra: offer.payExtra,
      strike: offer.strike,
      amountKnown: offer.amountKnown,
      supersetLoss: offer.supersetLoss,
      needs: offer.needs,
      url: bundle.url
    };
    var topImage = offer.topLine && offer.topLine.image;

    if (offer.type === 'switch') {
      return [Object.assign(base, {
        action: 'switch',
        title: bundleTitle,
        colour: 'Same items as one Full Stack',
        image: topImage || bundle.image,
        tag: fullStackTag(offer),
        // No price on this card: the saving is the point, and it costs nothing extra.
        priceText: offer.amountKnown ? (offer.supersetLoss > 0 ? 'Save ' + money(offer.saving) + ' more' : 'Save ' + money(offer.saving)) : 'Bundle saving',
        price: 0,
        strike: 0,
        pricePrefix: ''
      })];
    }

    if (offer.type === 'complete' && offer.piece === 'cap') {
      var cap = offer.candidate.missing || {};
      return [Object.assign(base, {
        action: 'convert',
        title: cap.title || 'Cap',
        colour: 'Completes your Full Stack',
        image: (offer.candidate.missingVariant && offer.candidate.missingVariant.image) || cap.image,
        url: cap.url || bundle.url,
        tag: fullStackTag(offer),
        price: offer.payExtra,
        strike: offer.strike > offer.payExtra ? offer.strike : 0,
        pricePrefix: '+'
      })];
    }

    if (offer.type === 'complete') {
      // Shorts are the one missing piece: pick a size, add it and convert.
      var rows = offer.candidate.rows || [];
      var seen = {};
      var shortsComponent = rows[0] && rows[0].shorts.component;
      var sizeVariants = [];
      rows.forEach(function (row) {
        if (seen[row.ids.shorts]) return;
        seen[row.ids.shorts] = true;
        sizeVariants.push(Object.assign({}, row.shorts.variant, { available: isAvailableVariant(row.shorts.variant) && isAvailableVariant(row.parent) }));
      });
      sizeVariants.sort(function (a, b) { return variantOrder(shortsComponent, a) - variantOrder(shortsComponent, b); });
      return [Object.assign(base, {
        action: 'size-convert',
        title: (shortsComponent && shortsComponent.title) || 'Shorts',
        colour: 'Completes your Full Stack',
        image: (rows[0] && (rows[0].shorts.variant.image || shortsComponent.image)) || bundle.image,
        url: (shortsComponent && shortsComponent.url) || bundle.url,
        tag: fullStackTag(offer),
        price: offer.payExtra,
        strike: offer.strike > offer.payExtra ? offer.strike : 0,
        pricePrefix: '+',
        sizes: sizeEntriesFor(shortsComponent, sizeVariants)
      })];
    }

    return [Object.assign(base, {
      action: 'upgrade',
      title: bundleTitle,
      colour: 'Add ' + missingWords(offer.needs),
      image: bundle.image || topImage,
      pieces: missingPieces(data, offer.needs),
      tag: fullStackTag(offer),
      price: offer.payExtra,
      strike: offer.strike > offer.payExtra ? offer.strike : 0,
      pricePrefix: '+'
    })];
  }

  // The cards for a cart, in order, at most MAX_CARDS. Rules (approved 21 Oct):
  //   - "Add a top" is the only Superset card (hidden at 4+ loose tops).
  //   - The cap and the shorts are single cards whenever the cart does not have them (a Full Stack counts as having them),
  //     except when the Full Stack offer is "complete with cap / shorts": that card is the cap or shorts card.
  //   - Switch: the switch card, then Add a top.
  //   - A cap or shorts in the cart: the Full Stack card, the missing single, Add a top.
  //   - Otherwise: Add a top, the Full Stack card, the cap, the shorts.
  function rankCards(data) {
    var ctx = cartContext(data);
    var roles = roleHandles(data);
    var offer = rankOffers(data).filter(function (item) { return item.type !== 'superset'; })[0] || null;
    var fullStack = offer ? fullStackCards(data, ctx, offer)[0] : null;
    var top = supersetCard(data, ctx);
    var covered = offer && offer.type === 'complete' ? offer.piece : '';
    var cap = !ctx.hasCap && !ctx.hasFullStack && covered !== 'cap' ? singleCard(data, roles.cap[0]) : null;
    var shorts = !ctx.hasShorts && !ctx.hasFullStack && covered !== 'shorts' ? singleCard(data, roles.shorts[0]) : null;
    var ordered;
    if (offer && offer.type === 'switch') ordered = [fullStack, top];
    else if (ctx.hasCap || ctx.hasShorts) ordered = [fullStack, cap, shorts, top];
    else ordered = [top, fullStack, cap, shorts];
    return ordered.filter(Boolean).slice(0, MAX_CARDS);
  }

  // ---- Offers band rendering -----------------------------------------------
  var ARROW = '→';

  // Every card button label, in one place. "add" is the outlined Add (cart icon in front);
  // build, upgrade and switchTo are the filled deal buttons. The empty cart uses the same cards and labels.
  var LABELS = { add: 'Add', build: 'Build ' + ARROW, upgrade: 'Upgrade ' + ARROW, switchTo: 'Switch ' + ARROW };

  // The cart icon of the homepage quick add (snippets/rd-inline-quick-add.liquid, rd_cart_icon).
  var CART_ICON = '<span class="rd-inline-quick-add__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 3h2l3 12h10l3-8H6" /><circle cx="9" cy="20" r="1" /><circle cx="18" cy="20" r="1" /></svg></span>';

  function addContent() {
    return CART_ICON + '<span>' + LABELS.add + '</span>';
  }

  // Analytics id: the Full Stack cards carry their bundle, "Add a top" is the Superset, the cap and shorts are singles.
  function cardAttrs(card, index) {
    var isBundle = card.kind === 'bundle';
    var offerId = isBundle ? 'cart-upsell-' + (card.bundleHandle || 'the-full-stack') : card.offer === 'single' ? 'cart-single' : 'cart-superset';
    return ' data-rd-oc-card data-rd-oc-index="' + index + '" data-rd-offer="' + escapeHtml(offerId) + '" data-rd-offer-placement="cart_drawer" data-rd-offer-type="' + (isBundle ? 'bundle' : 'product_upsell') + '"' +
      (card.handle || card.bundleHandle ? ' data-rd-offer-product="' + escapeHtml(card.handle || card.bundleHandle) + '"' : '') +
      ' data-rd-offer-card="' + escapeHtml(card.offer) + '" data-rd-offer-position="' + (index + 1) + '"';
  }

  // The homepage quick add component (rd-inline-quick-add), sheet variant: a panel that slides
  // up inside the card, over its lower part, so nothing is pushed or resized. Same markup and
  // classes as the colour sheet in snippets/rd-inline-quick-add.liquid (one colour, so no swatches).
  // rd-cart-upsell.js handles the form submit instead of product-form so the add carries the
  // offer properties and refreshes the drawer or the cart page.
  var qaSeq = 0;

  function quickAddHtml(card, index) {
    qaSeq += 1;
    var id = 'rd-oc-' + qaSeq;
    return '<rd-inline-quick-add class="rd-inline-quick-add rd-inline-quick-add--sheet rd-oc__qa" data-rd-inline-root data-rd-inline-section="rd-oc">' +
      '<button type="button" data-rd-inline-trigger data-rd-inline-sheet-trigger data-product-url="' + escapeHtml(card.url) + '" class="rd-inline-quick-add__trigger" aria-label="Choose a size for ' + escapeHtml(card.title) + '" aria-controls="' + id + '-sheet" aria-expanded="false" data-rd-offer-interaction="add_cta">' + addContent() + '</button>' +
      '<div id="' + id + '-sheet" class="rd-inline-quick-add__sheet" data-rd-inline-sheet role="group" aria-label="Choose a size for ' + escapeHtml(card.title) + '" hidden>' +
      '<div class="rd-inline-quick-add__sheet-head"><p class="rd-inline-quick-add__label">Select size</p>' +
      '<button type="button" class="rd-inline-quick-add__close" data-rd-inline-close aria-label="Close"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" /></svg></button></div>' +
      '<div class="rd-inline-quick-add__sizes rd-inline-quick-add__sizes--sheet" data-rd-inline-colour-sizes="' + escapeHtml(card.colour || card.title) + '" role="group" aria-label="Sizes">' +
      card.sizes.map(function (size) {
        return '<button type="button" class="rd-inline-quick-add__size" data-rd-inline-size data-rd-inline-variant-id="' + escapeHtml(size.id) + '" aria-label="Add size ' + escapeHtml(size.label) + '" aria-pressed="false"' + (size.available ? '' : ' disabled') + ' data-rd-offer-interaction="size_selection">' + escapeHtml(size.label) + '</button>';
      }).join('') +
      '</div>' +
      '<div class="rd-inline-quick-add__product-form">' +
      '<form id="' + id + '-form" class="form" novalidate data-rd-oc-form>' +
      '<input type="hidden" name="id" class="product-variant-id" value=""><input type="hidden" name="quantity" value="1">' +
      '<div class="rd-inline-quick-add__actions">' +
      '<button type="submit" name="add" class="rd-inline-quick-add__submit rd-inline-quick-add__submit--hidden" aria-live="polite" aria-disabled="true" aria-hidden="true" tabindex="-1" disabled><span class="visually-hidden">Add</span></button>' +
      '<span class="rd-inline-quick-add__status" data-rd-inline-status role="status" aria-live="polite"></span>' +
      '</div>' +
      '<div class="product-form__error-message-wrapper rd-inline-quick-add__error" role="alert" hidden><span class="product-form__error-message"></span></div>' +
      '</form></div>' +
      '</div></rd-inline-quick-add>';
  }

  function actionHtml(card, index) {
    var label = escapeHtml(card.title);
    if (card.action === 'size' || card.action === 'size-convert') return quickAddHtml(card, index);
    if (card.action === 'add') {
      return '<button type="button" class="rd-oc__btn rd-oc__btn--add" data-rd-oc-add data-variant-id="' + escapeHtml(card.variantId) + '" data-rd-offer-interaction="add_cta" aria-label="Add ' + label + '">' + addContent() + '</button>';
    }
    if (card.action === 'convert') {
      return '<button type="button" class="rd-oc__btn rd-oc__btn--add" data-rd-oc-convert data-rd-offer-interaction="primary_cta" aria-label="Add ' + label + ' and switch to The Full Stack">' + addContent() + '</button>';
    }
    if (card.action === 'build') {
      return '<button type="button" class="rd-oc__btn rd-oc__btn--deal" data-rd-oc-build data-rd-offer-interaction="primary_cta" aria-label="Build your Superset: add a top">' + LABELS.build + '</button>';
    }
    if (card.action === 'switch') {
      return '<button type="button" class="rd-oc__btn rd-oc__btn--deal" data-rd-oc-convert data-rd-offer-interaction="primary_cta" aria-label="Switch to The Full Stack">' + LABELS.switchTo + '</button>';
    }
    return '<button type="button" class="rd-oc__btn rd-oc__btn--deal" data-rd-oc-upgrade data-rd-offer-interaction="primary_cta" aria-label="Upgrade to The Full Stack">' + LABELS.upgrade + '</button>';
  }

  // One card for the whole band (the offers and the empty cart's tops row): badge on the top edge when there is
  // a tag, 104px photo or the Add a top grid, name, colour line, price row, a full-width 30px button.
  function cardHtml(card, index) {
    var image = card.image
      ? '<img class="rd-oc__img" src="' + escapeHtml(card.image) + '" alt="" width="320" height="320" decoding="async">'
      : '<span class="rd-oc__img" aria-hidden="true"></span>';
    if (card.gridImages && card.gridImages.length) {
      image = '<span class="rd-oc__grid4">' + card.gridImages.map(function (src) {
        return '<img class="rd-oc__tile" src="' + escapeHtml(src) + '" alt="" width="160" height="160" decoding="async">';
      }).join('') + '</span>';
    }
    // The tag is its own element: the badge on the card's top edge.
    var tag = card.tag ? '<span class="rd-oc__tag">' + escapeHtml(card.tag) + '</span>' : '';
    return '<article class="rd-oc__card rd-oc__card--' + escapeHtml(card.offer) + '"' + cardAttrs(card, index) + '>' +
      tag +
      '<a class="rd-oc__media" href="' + escapeHtml(card.url || '#') + '" tabindex="-1" aria-hidden="true">' + image + '</a>' +
      '<div class="rd-oc__body">' +
      '<p class="rd-oc__name">' + escapeHtml(card.title) + '</p>' +
      (card.pieces && card.pieces.images.length
        ? '<p class="rd-oc__pieces" aria-label="' + escapeHtml(card.colour) + '"><span class="rd-oc__plus" aria-hidden="true">+</span>' +
          card.pieces.images.map(function (src) { return '<img class="rd-oc__piece" src="' + escapeHtml(src) + '" alt="" width="60" height="60" decoding="async">'; }).join('') +
          '<span class="rd-oc__pieces-text" aria-hidden="true">' + escapeHtml(card.pieces.label) + '</span></p>'
        : (card.colour ? '<p class="rd-oc__colour">' + escapeHtml(card.colour) + '</p>' : '')) +
      (card.note ? '<p class="rd-oc__note">' + escapeHtml(card.note) + '</p>' : '') +
      '<p class="rd-oc__price"><b>' + (card.priceText ? escapeHtml(card.priceText) : (card.pricePrefix || '') + money(card.price)) + '</b>' + (card.strike ? ' <s>' + money(card.strike) + '</s>' : '') + '</p>' +
      '<div class="rd-oc__action">' + actionHtml(card, index) + '</div>' +
      '</div>' +
      '</article>';
  }

  function staticFullStackHtml(data, info) {
    var bundle = info.bundle;
    var image = bundle.image ? '<img class="rd-oc__img" src="' + escapeHtml(bundle.image) + '" alt="" width="320" height="320" decoding="async">' : '<span class="rd-oc__img" aria-hidden="true"></span>';
    return '<article class="rd-oc__static" data-rd-oc-static data-rd-offer="cart-upsell-' + escapeHtml(bundle.handle || 'the-full-stack') + '" data-rd-offer-placement="cart_drawer" data-rd-offer-type="bundle" data-rd-offer-product="' + escapeHtml(bundle.handle || '') + '" data-rd-offer-card="static">' +
      '<a class="rd-oc__media" href="' + escapeHtml(bundle.url || '#') + '" tabindex="-1" aria-hidden="true">' + image + '</a>' +
      '<div class="rd-oc__body">' +
      '<p class="rd-oc__name">' + escapeHtml(bundle.title || 'The Full Stack') + '</p>' +
      '<p class="rd-oc__price"><b>' + money(info.price) + '</b>' + (info.strike ? ' <s>' + money(info.strike) + '</s>' : '') + '</p>' +
      '<p class="rd-oc__note">A cap, shorts and any top.' + (info.saving ? ' Save ' + money(info.saving) + '.' : '') + '</p>' +
      '<div class="rd-oc__action"><button type="button" class="rd-oc__btn rd-oc__btn--deal" data-rd-oc-upgrade data-rd-offer-interaction="primary_cta" aria-label="Build The Full Stack">' + LABELS.build + '</button></div>' +
      '</div></article>';
  }

  function bandHtml(cards, data) {
    var staticInfo = data && data.isEmpty ? emptyFullStack(data) : null;
    return '<div class="rd-oc__track" data-rd-oc-track tabindex="0" role="group" aria-label="Offers">' +
      cards.map(cardHtml).join('') +
      '</div>' +
      (cards.length > 1 ? '<div class="rd-oc__dots" data-rd-oc-dots>' + cards.map(function (card, i) {
        return '<button type="button" class="rd-oc__dot' + (i === 0 ? ' is-on' : '') + '" data-rd-oc-dot="' + i + '" aria-label="Offer ' + (i + 1) + ' of ' + cards.length + '"></button>';
      }).join('') + '</div>' : '') +
      (staticInfo ? staticFullStackHtml(data, staticInfo) : '') +
      errorSlot();
  }

  function errorSlot() {
    return '<p class="rd-oc__error" data-rd-cart-upsell-error role="alert" hidden></p>';
  }

  function renderNotice(message) {
    return '<p class="rd-oc__error" data-rd-cart-upsell-error role="alert">' + escapeHtml(message) + '</p>';
  }

  // Dots follow the swipe row.
  function bindTrack(mount) {
    var track = mount.querySelector('[data-rd-oc-track]');
    var dots = mount.querySelectorAll('[data-rd-oc-dot]');
    if (!track || !dots.length) return;
    var cards = track.querySelectorAll('[data-rd-oc-card]');
    function step() {
      return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var index = max > 0 && track.scrollLeft >= max - 2 ? cards.length - 1 : Math.round(track.scrollLeft / (step() || 1));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-on', i === index);
      });
    }
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var target = cards[Number(dot.getAttribute('data-rd-oc-dot'))];
        if (target && track.scrollTo) track.scrollTo({ left: target.offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
      });
    });
  }

  // Previous / next arrows on the heading row (the swipe row has no handle for a mouse). They scroll the track by one card
  // (card width plus gap); the track snaps as before and the dashes follow its scroll. Shown only when the cards overflow.
  // The buttons live in snippets/rd-cart-upsell.liquid outside the re-rendered mount, so handlers are assigned (not added)
  // and always read the current track.
  function bindNav(band, track) {
    var nav = band && band.querySelector('[data-rd-oc-nav]');
    if (!nav || !track) return;
    var prev = nav.querySelector('[data-rd-oc-prev]');
    var next = nav.querySelector('[data-rd-oc-next]');
    if (!prev || !next) return;
    function step() {
      var cards = track.querySelectorAll('[data-rd-oc-card]');
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      return cards[0] ? cards[0].offsetWidth : track.clientWidth;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      nav.hidden = !(max > 2);
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 2;
    }
    function go(direction) {
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var left = direction * step();
      if (track.scrollBy) track.scrollBy({ left: left, behavior: calm ? 'auto' : 'smooth' });
      else track.scrollLeft += left;
    }
    prev.onclick = function () { go(-1); };
    next.onclick = function () { go(1); };
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });
    // Sizes change when the drawer opens or the window is resized.
    if (window.ResizeObserver) new window.ResizeObserver(sync).observe(track);
    else window.addEventListener('resize', sync);
    sync();
  }

  // The component loads once per page: rd-cart-upsell.js is the only script that needs it here.
  function ensureQuickAdd(data) {
    var assets = data.assets || {};
    if (assets.quickAddCss && !document.querySelector('link[data-rd-oc-asset="qa-css"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = assets.quickAddCss;
      link.setAttribute('data-rd-oc-asset', 'qa-css');
      document.head.appendChild(link);
    }
    if (assets.quickAddJs && !(window.customElements && window.customElements.get('rd-inline-quick-add')) && !document.querySelector('script[data-rd-oc-asset="qa-js"]')) {
      var script = document.createElement('script');
      script.src = assets.quickAddJs;
      script.defer = true;
      script.setAttribute('data-rd-oc-asset', 'qa-js');
      document.head.appendChild(script);
    }
  }

  function render(root) {
    var script = root.querySelector('[data-rd-cart-upsell-data]');
    var mount = root.querySelector('[data-rd-cart-upsell-mount]');
    var band = root.closest ? root.closest('[data-rd-oc-band]') : null;
    if (!script || !mount) return;

    function setBand(visible) {
      root.hidden = !visible;
      if (band) band.hidden = !visible;
    }

    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (error) {
      mount.innerHTML = '';
      setBand(false);
      return;
    }

    // The empty cart renders the same band in whichever surface holds it.
    if (data.context === 'empty') {
      data.isEmpty = true;
      data.context = root.closest && root.closest('cart-drawer') ? 'drawer' : 'page';
    }
    root._rdUpsellData = data;
    setMoneyFormat(data.moneyZero);

    try {
      var cards = data.isEmpty ? emptyCards(data) : rankCards(data);
      var html = cards.length ? bandHtml(cards, data) : '';
      root._rdUpsellCards = cards;

      var pendingError = takePendingError(data.context);
      if (pendingError && !html) html = renderNotice(pendingError);

      // Keep closed-drawer offer photos off the initial network queue. The
      // offer data and automatic pricing logic still initialize normally.
      var drawer = root.closest && root.closest('cart-drawer');
      if (drawer && !drawer.classList.contains('active')) {
        html = html.replace(/(<img\b[^>]*?)\bsrc="/g, '$1data-rd-offer-src="');
      }
      mount.innerHTML = html;
      setBand(!!html);
      if (pendingError && cards.length) showError(root, pendingError);
      if (cards.length) {
        ensureQuickAdd(data);
        bindTrack(mount);
        bindNav(band, mount.querySelector('[data-rd-oc-track]'));
      }

      var switchCard = cards.filter(function (card) { return card.action === 'switch'; })[0];
      if (switchCard && data.mode === 'automatic') {
        var candidate = switchCard.candidate;
        var key = candidate.bundle.handle + ':' + candidate.lines.map(function (line) { return line.key; }).sort().join('|');
        var seen = false;
        try {
          seen = !!sessionStorage.getItem('rd-cart-upsell-auto:' + key);
          if (!seen) sessionStorage.setItem('rd-cart-upsell-auto:' + key, '1');
        } catch (error) {
          seen = false;
        }
        if (!autoKeys[key] && !seen) {
          autoKeys[key] = true;
          setTimeout(function () {
            convertBundle(root, candidate);
          }, 250);
        }
      }
    } catch (error) {
      if (window.console && console.error) console.error('rd-cart-upsell render failed', error);
      mount.innerHTML = '';
      setBand(false);
    }
  }

  function setBusy(root, busy) {
    root.classList.toggle('is-loading', busy);
    root.querySelectorAll('button, select').forEach(function (control) {
      control.disabled = busy;
    });
  }

  function showError(root, message) {
    var error = root.querySelector('[data-rd-cart-upsell-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function selectedMissingValue(root, candidate) {
    if (candidate.type !== 'partial') return null;
    if (componentIsOneSize(candidate.missing)) return 'One Size';
    var selected = root.querySelector('[data-rd-missing-size].is-selected');
    return selected ? selected.dataset.rdMissingSize : '';
  }

  function enrichPartialCandidate(root, candidate) {
    if (candidate.type !== 'partial') return candidate;
    if (candidate.native && candidate.variant) return candidate;
    var value = selectedMissingValue(root, candidate);
    if (!value) return null;
    var selections = Object.assign({}, candidate.selections);
    selections[candidate.missing.handle] = value;
    var variant = resolveBundleVariant(candidate.bundle, selections);
    if (!variant) return null;
    return Object.assign({}, candidate, { selections: selections, variant: variant });
  }

  function convertBundle(root, rawCandidate) {
    var candidate = enrichPartialCandidate(root, rawCandidate);
    if (!candidate || !candidate.variant) {
      showError(root, 'Choose a valid size to complete the stack.');
      return Promise.resolve();
    }

    setBusy(root, true);
    showError(root, '');

    var context = root._rdUpsellData && root._rdUpsellData.context;
    var operationId = rdUuid();
    var removeUpdates = {};
    candidate.lines.forEach(function (line) {
      // A component line with quantity > 1 only contributes one unit to the
      // bundle: decrement instead of removing, so the rest stays in the cart.
      removeUpdates[line.key] = Math.max(0, cartLineQuantity(line) - 1);
    });

    // The offer surface is the rendered bundle card: read its data-rd-offer*
    // attributes so the add carries the same offer id/placement the card was
    // tagged with, falling back to the values used elsewhere in this file if
    // the card isn't found (e.g. in the automatic-conversion timing window).
    var surfaceEl = root.querySelector && root.querySelector('[data-rd-offer-type="bundle"]');
    var offerId = (surfaceEl && surfaceEl.getAttribute && surfaceEl.getAttribute('data-rd-offer')) ||
      ('cart-upsell-' + (candidate.bundle && candidate.bundle.handle ? candidate.bundle.handle : ''));
    var offerPlacement = (surfaceEl && surfaceEl.getAttribute && surfaceEl.getAttribute('data-rd-offer-placement')) || 'cart_drawer';
    var addBody = { id: candidate.variant.id, quantity: 1 };
    if (offerId && offerPlacement) {
      addBody.properties = {
        _rd_offer_id: offerId,
        _rd_offer_version: 'v1',
        _rd_offer_placement: offerPlacement
      };
    }

    return postJson(routesFallback('cart_add_url', '/cart/add.js'), addBody)
      .then(function () {
        return postJson(routesFallback('cart_update_url', '/cart/update.js'), withRenderedSections({
          updates: removeUpdates
        }, context));
      })
      .then(function (cartState) {
        dispatchOfferAdded({
          offerId: 'cart-upsell-' + (candidate.bundle && candidate.bundle.handle ? candidate.bundle.handle : ''),
          placement: 'cart_drawer',
          offerType: 'bundle',
          variantId: candidate.variant && candidate.variant.id,
          operationId: operationId,
          cartTotalCents: cartState && typeof cartState.total_price === 'number' ? cartState.total_price : undefined
        });
        return renderCartSections(cartState, context);
      })
      .catch(function () {
        var message = 'Could not switch these items to a bundle. Your cart was refreshed.';
        storePendingError(context, message);
        return refreshCart(context).catch(function () {
          showError(root, message);
        });
      })
      .finally(function () {
        setBusy(root, false);
      });
  }

  function replaceSection(id, selector, html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var target = selector ? document.querySelector(selector) : document.getElementById(id);
    var source = selector ? parsed.querySelector(selector) : parsed.getElementById(id);
    if (!source) source = parsed.querySelector('.shopify-section');
    if (target && source) target.innerHTML = source.innerHTML;
  }

  function renderCartSections(payload, context) {
    if (!payload || !payload.sections) return refreshCart(context);

    var sectionHtml = payload.sections;
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var itemsSectionId = itemsEl && itemsEl.dataset.id;
    var footerSectionId = footerEl && footerEl.dataset.id;

    if (sectionHtml['cart-drawer']) replaceSection('CartDrawer', '#CartDrawer', sectionHtml['cart-drawer']);
    if (sectionHtml['cart-icon-bubble']) replaceSection('cart-icon-bubble', '#cart-icon-bubble', sectionHtml['cart-icon-bubble']);
    if (itemsSectionId && sectionHtml[itemsSectionId]) replaceSection('main-cart-items', '#main-cart-items .js-contents', sectionHtml[itemsSectionId]);
    if (footerSectionId && sectionHtml[footerSectionId]) replaceSection('main-cart-footer', '#main-cart-footer .js-contents', sectionHtml[footerSectionId]);

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      // /cart/add.js answers with the added line, not the cart, so fall back to the rendered drawer.
      var drawerEmpty = typeof payload.item_count === 'number'
        ? payload.item_count === 0
        : !!document.querySelector('#CartDrawer .drawer__inner-empty');
      drawer.classList.toggle('is-empty', drawerEmpty);
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof drawer.close === 'function') {
        overlay.addEventListener('click', drawer.close.bind(drawer));
      }
      // Only open a closed drawer: Dawn's open() on an open drawer leaves a
      // transitionend listener behind that later pulls focus to the drawer.
      if (context === 'drawer' && typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
    }
    var footer = document.getElementById('main-cart-footer');
    if (footer && typeof payload.item_count === 'number') footer.classList.toggle('is-empty', payload.item_count === 0);

    if (window.publish && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'rd-cart-upsell', cartData: payload });
    }

    window.RDCartUpsell.init();
    return payload;
  }

  function refreshCart(context) {
    var cartUrl = routesFallback('cart_url', '/cart');
    var sections = getSectionsToRender(context);

    return Promise.all([
      fetchJson(routesFallback('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } }),
      // No Accept header here: with "Accept: application/json" Shopify answers /cart with the cart JSON, not the sections.
      fetchJson(cartUrl + '?sections=' + sections.join(',') + '&sections_url=' + encodeURIComponent(window.location.pathname))
    ]).then(function (results) {
      var cart = results[0];
      cart.sections = results[1];
      return renderCartSections(cart, context);
    });
  }

  function publishQuickAdd(kind, variantId, message) {
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(kind === 'error' ? window.PUB_SUB_EVENTS.cartError : window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId,
          message: message || ''
        });
      }
    } catch (error) {
      // the quick add component resets itself when the band re-renders
    }
  }

  // Add one variant from a card (a Superset top in the chosen size).
  function addVariant(root, variantId, surface) {
    if (!variantId) {
      showError(root, 'Pick a size first.');
      return Promise.resolve();
    }

    setBusy(root, true);
    showError(root, '');

    var context = root._rdUpsellData && root._rdUpsellData.context;
    var operationId = rdUuid();
    var dataset = (surface && surface.dataset) || {};
    var offerId = dataset.rdOffer || '';
    var offerPlacement = dataset.rdOfferPlacement || '';

    var addBody = { id: Number(variantId), quantity: 1 };
    if (offerId && offerPlacement) {
      addBody.properties = {
        _rd_offer_id: offerId,
        _rd_offer_version: 'v1',
        _rd_offer_placement: offerPlacement
      };
    }

    return postJson(routesFallback('cart_add_url', '/cart/add.js'), withRenderedSections(addBody, context))
      .then(function (cartState) {
        if (offerId) {
          dispatchOfferAdded({
            offerId: offerId,
            placement: 'cart_drawer',
            offerType: dataset.rdOfferType || 'product_upsell',
            variantId: variantId,
            operationId: operationId,
            cartTotalCents: cartState && typeof cartState.total_price === 'number' ? cartState.total_price : undefined
          });
        }
        publishQuickAdd('ok', variantId);
        // The cart page's empty state is not a re-rendered section: reload it with the item in.
        if (root._rdUpsellData && root._rdUpsellData.isEmpty && context === 'page') {
          window.location.reload();
          return cartState;
        }
        return renderCartSections(cartState, context);
      })
      .catch(function () {
        var message = 'Could not add this item. Your cart was refreshed.';
        publishQuickAdd('error', variantId, message);
        storePendingError(context, message);
        return refreshCart(context).catch(function () {
          showError(root, message);
        });
      })
      .finally(function () {
        setBusy(root, false);
      });
  }

  // Shorts card: the chosen size completes the stack, so add it and convert to the bundle.
  function convertWithShorts(root, card, shortsVariantId) {
    var candidate = card.candidate;
    var row = (candidate.rows || []).find(function (item) {
      return item.ids.shorts === String(shortsVariantId);
    });
    if (!row || !isAvailableVariant(row.parent)) {
      showError(root, 'That combination is sold out. Try another size.');
      publishQuickAdd('error', shortsVariantId, 'Sold out');
      return Promise.resolve();
    }
    return convertBundle(root, Object.assign({}, candidate, { type: 'full', variant: row.parent }));
  }

  // The Full Stack upgrade drawer is built elsewhere; until it exists, go to the product.
  function openUpgrade(card) {
    var upgrade = window.RDFullStackUpgrade;
    if (upgrade && typeof upgrade.open === 'function') {
      try {
        if (upgrade.open() !== false) return;
      } catch (error) {
        // fall through to the product page
      }
    }
    window.location.href = card.url || '/products/the-full-stack';
  }

  // "Add a top" opens the Superset builder sheet; without it, the Superset collection.
  function openBuilder(button, card) {
    var builder = window.RDSupersetBuilder;
    if (builder && typeof builder.open === 'function') {
      try {
        if (builder.open({ opener: button }) !== false) return;
      } catch (error) {
        // fall through to the collection
      }
    }
    window.location.href = (card && card.url) || '/collections/superset-tees';
  }

  function bind(root) {
    if (root._rdUpsellBound) return;
    root._rdUpsellBound = true;

    function cardFor(element) {
      var cardEl = element.closest('[data-rd-oc-card]');
      var card = cardEl && root._rdUpsellCards && root._rdUpsellCards[Number(cardEl.getAttribute('data-rd-oc-index'))];
      return card ? { el: cardEl, card: card } : null;
    }

    root.addEventListener('submit', function (event) {
      var form = event.target && event.target.closest && event.target.closest('[data-rd-oc-form]');
      if (!form) return;
      event.preventDefault();
      var found = cardFor(form);
      var input = form.querySelector('[name="id"]');
      var variantId = input ? input.value : '';
      if (!found || !variantId) return;
      if (found.card.action === 'size-convert') convertWithShorts(root, found.card, variantId);
      else addVariant(root, variantId, found.el);
    });

    root.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-rd-oc-add]');
      if (addButton) {
        event.preventDefault();
        var addCard = cardFor(addButton);
        addVariant(root, addButton.getAttribute('data-variant-id'), addCard && addCard.el);
        return;
      }

      var convert = event.target.closest('[data-rd-oc-convert]');
      if (convert) {
        event.preventDefault();
        var found = cardFor(convert);
        convertBundle(root, found && found.card.candidate);
        return;
      }

      var build = event.target.closest('[data-rd-oc-build]');
      if (build) {
        event.preventDefault();
        var buildCard = cardFor(build);
        openBuilder(build, buildCard && buildCard.card);
        return;
      }

      var upgrade = event.target.closest('[data-rd-oc-upgrade]');
      if (upgrade) {
        event.preventDefault();
        var target = cardFor(upgrade);
        var staticCard = upgrade.closest('[data-rd-oc-static]');
        openUpgrade(target ? target.card : { url: staticCard ? staticCard.querySelector('a').getAttribute('href') : '' });
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-rd-cart-upsell]').forEach(function (root) {
      var drawer = root.closest && root.closest('cart-drawer');
      if (root.dataset.context === 'empty' && drawer && !drawer.classList.contains('active')) {
        root.setAttribute('data-rd-offers-pending', '');
        return;
      }
      root.removeAttribute('data-rd-offers-pending');
      bind(root);
      render(root);
    });
  }

  function revealImages(scope) {
    scope.querySelectorAll('[data-rd-offers-pending]').forEach(function (root) {
      root.removeAttribute('data-rd-offers-pending');
      bind(root);
      render(root);
    });
    scope.querySelectorAll('img[data-rd-offer-src]').forEach(function (image) {
      image.src = image.getAttribute('data-rd-offer-src');
      image.removeAttribute('data-rd-offer-src');
    });
  }

  window.RDCartUpsell = {
    revealImages: revealImages,
    init: init,
    refreshCart: refreshCart,
    rankOffers: rankOffers,
    rankCards: rankCards
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  var WATCH = '[data-rd-cart-upsell]';
  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1 && (node.matches(WATCH) || (node.querySelector && node.querySelector(WATCH)));
      });
    })) {
      init();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
